(() => {
  if (customElements.get('timeline-scroll')) {
    return;
  }

  class TimelineScroll extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * Get start point.
     *
     * @returns {Number}
     */
    getStartPoint() {
      return this.getBoundingClientRect().top + window.scrollY;
    }

    /**
     * Init.
     */
    init() {
      this.start = this.getBoundingClientRect().top + window.scrollY;
      this.height = this.getBoundingClientRect().height;
      this.endPoint = this.start + this.height;

      this.setVisiblePortion(0);
    }

    /**
     * Set visible portion.
     *
     * @param {Number} percentage
     * @param {Number} pointReached
     * @returns {Void}
     */
    setVisiblePortion(percentage, pointReached) {
      this.style.setProperty('--visible-portion', `${percentage}%`);

      if (!this.timelines) {
        return;
      }

      if (percentage === 100) {
        this.timelines.forEach((timeline) => {
          timeline.classList.add('is-reached');
        });
        return;
      }
      if (percentage === 0) {
        this.timelines.forEach((timeline) => {
          timeline.classList.remove('is-reached');
        });
        return;
      }
      this.timelines.forEach((timeline) => {
        const timelineStart = timeline.getBoundingClientRect().top + window.scrollY;
        const isReached = pointReached > timelineStart;
        timeline.classList.toggle('is-reached', isReached);
      });
    }

    /**
     * On scroll.
     *
     * @returns {Void}
     */
    onScroll() {
      if (this.start !== this.getStartPoint()) {
        this.init();
      }

      const scrollOffset = window.scrollY + window.innerHeight * 0.5;
      const hasPassed = scrollOffset > this.start;
      if (!hasPassed) {
        this.setVisiblePortion(0);
        return;
      }

      const visiblePortion = Math.min(scrollOffset - this.start, this.height);
      const percentage = visiblePortion / this.height;

      if (percentage > 100) {
        this.setVisiblePortion(100);
        return;
      }

      this.setVisiblePortion(percentage * 100, scrollOffset);
    }

    /**
     * On resize.
     */
    onResize() {
      this.init();
      this.onScroll();
    }

    /**
     * Setup handlers.
     */
    setupHandlers() {
      window.addEventListener('scroll', this.onScroll.bind(this));
      window.addEventListener('resize', this.onResize.bind(this));
    }

    /**
     * Remove handlers.
     */
    connectedCallback() {
      this.init();
      this.timelines = this.querySelectorAll('[data-timeline]');
      this.setupHandlers();
    }
  }

  customElements.define('timeline-scroll', TimelineScroll);
})();
